import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useContext, useMemo } from 'react';
import Feedback from './Feedback';
import FormCheckInput from './FormCheckInput';
import FormCheckLabel from './FormCheckLabel';
import FormContext from './FormContext';
import { useBootstrapPrefix } from './ThemeProvider';
import { hasChildOfType } from './ElementChildren';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FormCheck = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    bsPrefix = _ref.bsPrefix,
    bsSwitchPrefix = _ref.bsSwitchPrefix,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    _ref$isInvalid = _ref.isInvalid,
    isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
    _ref$feedbackTooltip = _ref.feedbackTooltip,
    feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip,
    feedback = _ref.feedback,
    feedbackType = _ref.feedbackType,
    className = _ref.className,
    style = _ref.style,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'checkbox' : _ref$type,
    label = _ref.label,
    children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'input' : _ref$as,
    props = _objectWithoutProperties(_ref, ["id", "bsPrefix", "bsSwitchPrefix", "inline", "reverse", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "feedbackType", "className", "style", "title", "type", "label", "children", "as"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check');
  bsSwitchPrefix = useBootstrapPrefix(bsSwitchPrefix, 'form-switch');
  var _useContext = useContext(FormContext),
    controlId = _useContext.controlId;
  var innerFormContext = useMemo(function () {
    return {
      controlId: id || controlId
    };
  }, [controlId, id]);
  var hasLabel = !children && label != null && label !== false || hasChildOfType(children, FormCheckLabel);
  var input = /*#__PURE__*/_jsx(FormCheckInput, _objectSpread({}, props, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: as
  }));
  return /*#__PURE__*/_jsx(FormContext.Provider, {
    value: innerFormContext,
    children: /*#__PURE__*/_jsx("div", {
      style: style,
      className: classNames(className, hasLabel && bsPrefix, inline && "".concat(bsPrefix, "-inline"), reverse && "".concat(bsPrefix, "-reverse"), type === 'switch' && bsSwitchPrefix),
      children: children || /*#__PURE__*/_jsxs(_Fragment, {
        children: [input, hasLabel && /*#__PURE__*/_jsx(FormCheckLabel, {
          title: title,
          children: label
        }), feedback && /*#__PURE__*/_jsx(Feedback, {
          type: feedbackType,
          tooltip: feedbackTooltip,
          children: feedback
        })]
      })
    })
  });
});
FormCheck.displayName = 'FormCheck';
export default Object.assign(FormCheck, {
  Input: FormCheckInput,
  Label: FormCheckLabel
});